var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "17", height: "16", viewBox: "0 0 17 16" }, props),
    React.createElement("path", { d: "M13.978 6c1.012.085 1.835 1.096 1.866 2.111v.875c.026 1.058-.809 1.985-1.866 2.014H4c-.306-.001-1.736-.589-4.29-1.763-.189-.186-.296-.44-.297-.707 0-.297.132-.58.36-.77C2.286 6.588 3.695 6 4 6h9.978zM3.973 7.011L.462 8.532 4 10l.026-.001-.053-2.988zM13.978 7H12v3h1.978c.506-.014.879-.483.867-.99v-.868C14.829 7.635 14.4 7.04 13.978 7zM11 7l-6.027-.001.055 2.992-.472.008L11 10V7z", transform: "rotate(-45 7.9 7.845)", fill: "#303030", fillRule: "evenodd" })
  );
});